import {
  NutrientDetailsBox,
  NutrientDetailsItemLabel,
  NutrientDetailsItemValue,
  NutrientDetailsWrapper,
  NutrientUnit,
} from "./styled"
import { getDisplayCalories } from "utils"
import { FlexBox } from "components/Common/FlexBox"
import NutrientPieChart from "./NutrientPieChart"
import { IGoal } from "features/onboarding/types"

interface INutrientDetailsItem {
  name: string
  color: string
  value: number
}

const NutrientDetailsItem = (props: INutrientDetailsItem) => {
  const { name, color, value } = props
  return (
    <NutrientDetailsWrapper>
      <NutrientDetailsItemLabel $color={color}>{name}</NutrientDetailsItemLabel>

      <NutrientDetailsItemValue>
        {" "}
        {getDisplayCalories(value)}
      </NutrientDetailsItemValue>

      <NutrientUnit>g</NutrientUnit>
    </NutrientDetailsWrapper>
  )
}

const YourGoalDailyNutriton = ({ goal }: { goal?: IGoal }) => {
  const nutrient: INutrientDetailsItem[] = [
    {
      name: "Protein",
      value: goal?.proteinGram ?? 0,
      color: "#FB6DEB",
    },
    {
      name: "Fat",
      value: goal?.fatGram ?? 0,
      color: "#F7C945",
    },
    {
      name: "Carbs",
      value: goal?.carbsGram ?? 0,
      color: "#A17CFE",
    },
  ]

  const nutrientPieChatData: INutrientDetailsItem[] = [
    {
      name: "Protein",
      value: goal?.protein ?? 0,
      color: "#FB6DEB",
    },
    {
      name: "Fat",
      value: goal?.fat ?? 0,
      color: "#F7C945",
    },
    {
      name: "Carbs",
      value: goal?.carb ?? 0,
      color: "#A17CFE",
    },
  ]

  return (
    <FlexBox $gap={16} $justify="space-between" style={{ width: "100%" }}>
      <NutrientPieChart
        nutrient={nutrientPieChatData}
        calorie={goal?.caloriesPerDay ?? 0}
      />

      <NutrientDetailsBox>
        {nutrient.map((data, index) => (
          <NutrientDetailsItem key={index} {...data} />
        ))}
      </NutrientDetailsBox>
    </FlexBox>
  )
}

export default YourGoalDailyNutriton
